module.exports = __webpack_public_path__ + "static/media/error_app_icon.25130744.png";